import { render, staticRenderFns } from "./DishRating.vue?vue&type=template&id=3161d1e6&scoped=true"
import script from "./DishRating.vue?vue&type=script&lang=js"
export * from "./DishRating.vue?vue&type=script&lang=js"
import style0 from "./DishRating.vue?vue&type=style&index=0&id=3161d1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3161d1e6",
  null
  
)

export default component.exports